
		<div class="amplify-component">
			<ng-template component-host></ng-template>
		</div>
	


// WEBPACK FOOTER //
// ./node_modules/aws-amplify-angular/dist/src/components/storage/photo-picker-component/photo-picker.factory.d.ts.PhotoPickerComponent.html